module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/media/personality-relax-beijing.9294bdc7.mp4";